import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';
import {validatable} from 'components/utils';

class DropDownChonPhuongXa extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      allData: []
    }
  }
  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
    if (this.props.quanHuyenId)
      this.loadData(this.props.quanHuyenId);
  }

  loadData(quanHuyenId) {
    DuLieuHeThong.actions.getCapPhuongXa.request({id: quanHuyenId}).then(res => {
      if (typeof res.data._embedded != "undefined") {
        // TODO: Use Redux

        this.setState({
          data: res.data._embedded.donViHanhChinhs
        })
      } else {
        this.setState({
          data: []
        });
      }
    }).catch(err => {})
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.quanHuyenId != nextProps.quanHuyenId) {
      if (nextProps.quanHuyenId) {
        if (typeof this.state.allData[nextProps.quanHuyenId] != "undefined") {
          this.setState({
            data: this.props.data[nextProps.quanHuyenId]
          });
        } else {
          this.loadData(nextProps.quanHuyenId);
        }
      } else {
        this.setState({
          data: []
        });
      }
    }
    if (this.props.thanhPhoID != nextProps.thanhPhoID) {
      this.setState({
        data: []
      });
    }
  }

  render() {
    return (
      <DropDown disabled={this.props.disabled} className={this.props.className} selectedValue={this.props.selectedValue}
      label="Phường/Xã" options={ this.state.data } keyName='donViHanhChinhId' valueName='ten'
      onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder }
      bindValidator={this} channel="danhMuc" require = {this.props.require}
      name="phuongXa"
      />
    )
  }
}

DropDownChonPhuongXa.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  isValid: false,
  require: false,
  disabled: false
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.capPhuongXa
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonPhuongXa));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-phuongxa.jsx